import BaseModelAPI from '../BaseModelAPI';

export default class ReportMTBFList extends BaseModelAPI {

	static entity = 'newreport2017list'
	static entityName = 'reportmtbf';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
